import { LineReveal, FadeUp } from "../components/Reveal";
import { ArrowUpRight } from "lucide-react";
import { posts } from "../data/blog";

export default function Blog() {
  const [featured, ...rest] = posts;
  return (
    <main data-testid="blog-page" className="pt-[112px]">
      <section className="py-16 md:py-24">
        <div className="mx-auto max-w-[1440px] px-6 md:px-10">
          <div className="flex items-center gap-3 mb-10">
            <span className="rule" /><span className="overline">Volume I — The Journal</span>
          </div>
          <h1 className="font-serif font-light tracking-[-0.02em] leading-[0.94] text-[12vw] md:text-[8.5vw]">
            <LineReveal
              lines={[
                <>Notes on the</>,
                <><em className="italic text-[#C26D5C]">working</em> life.</>,
              ]}
              stagger={0.12}
              delay={0.1}
            />
          </h1>
          <FadeUp delay={0.4}>
            <p className="mt-10 max-w-2xl text-base md:text-lg leading-relaxed text-[#1A1C1A]/80">
              Field notes, essays, and the occasional interview — a slow read on the questions that shape a career. Published when we have something to say.
            </p>
          </FadeUp>
        </div>
      </section>

      {/* Featured */}
      <section className="pb-16">
        <div className="mx-auto max-w-[1440px] px-6 md:px-10">
          <FadeUp>
            <a href="#" data-testid={`blog-featured-${featured.slug}`} className="group grid grid-cols-12 gap-6 md:gap-10 items-center border-t border-[#1A1C1A] pt-10">
              <div className="col-span-12 md:col-span-7">
                <div className="aspect-[16/10] overflow-hidden border border-[#D1CDC7]">
                  <img src={featured.cover} alt={featured.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
                </div>
              </div>
              <div className="col-span-12 md:col-span-5">
                <div className="overline text-[#C26D5C] mb-4">Featured — {featured.category}</div>
                <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light tracking-tight leading-[1.02] group-hover:text-[#C26D5C] transition-colors duration-500">
                  {featured.title}
                </h2>
                <p className="mt-6 text-base leading-relaxed text-[#1A1C1A]/80">{featured.excerpt}</p>
                <div className="mt-8 flex items-center gap-6 text-xs uppercase tracking-[0.2em] text-[#1A1C1A]/60">
                  <span>{featured.date}</span>
                  <span>{featured.readTime}</span>
                </div>
                <div className="mt-8 inline-flex items-center gap-2 text-sm border-b border-[#1A1C1A] pb-1 group-hover:text-[#C26D5C] group-hover:border-[#C26D5C] transition-colors">
                  Read the essay <ArrowUpRight size={14} />
                </div>
              </div>
            </a>
          </FadeUp>
        </div>
      </section>

      {/* Grid */}
      <section className="pb-32">
        <div className="mx-auto max-w-[1440px] px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-14">
            {rest.map((p, i) => (
              <FadeUp key={p.slug} delay={i * 0.05}>
                <a href="#" data-testid={`blog-card-${p.slug}`} className="group block">
                  <div className="aspect-[4/5] overflow-hidden border border-[#D1CDC7] mb-6 relative">
                    <img src={p.cover} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
                    <div className="absolute top-4 left-4 overline text-[#F4F2F0] bg-[#1A1C1A]/70 px-2 py-1">
                      {p.number} · {p.category}
                    </div>
                  </div>
                  <h3 className="font-serif text-3xl font-light tracking-tight leading-tight group-hover:text-[#C26D5C] transition-colors duration-300">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#1A1C1A]/80">{p.excerpt}</p>
                  <div className="mt-5 flex items-center gap-6 text-xs uppercase tracking-[0.2em] text-[#1A1C1A]/60">
                    <span>{p.date}</span>
                    <span>{p.readTime}</span>
                  </div>
                </a>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
